module.exports = __webpack_public_path__ + "img/The-Japanese-payment-system-JCB-has-suspended-work-in-the.4d411374.jpeg";